<template>
  <el-container>
    <el-main>
     
      <el-form :inline="true" :model="formApartment" class="demo-form-inline">
        <el-form-item :label="$t('deviceApartmentList.apartmentName')">
          <el-input v-model="formApartment.apartmentName" style="width:200px" :placeholder="$t('deviceApartmentList.apartmentName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('deviceApartmentList.area')">
          <el-input style="width:180px" v-show="language=='en'" v-model="formApartment.province" :placeholder="$t('addApartmentFSS.province')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="formApartment.province"
          clearable
          @change="getProvinceValue"
          style="width:200px"
          :placeholder="$t('deviceApartmentList.province')"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.provinceList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-input style="width:180px" v-show="language=='en'" v-model="formApartment.city" :placeholder="$t('addApartmentFSS.city')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="formApartment.city"
          clearable
          @change="getCityValue"
          style="width:200px"
          :placeholder="$t('deviceApartmentList.city')"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.cityList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
       </el-select>
       <el-input style="width:180px" v-show="language=='en'" v-model="formApartment.area" :placeholder="$t('addApartmentFSS.area-county')"></el-input>
       <el-select
          v-show="language=='zh'"
          v-model="formApartment.area"
          clearable
          :placeholder="$t('deviceApartmentList.area-county')"
          style="width:200px"
          prop="area"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.areaList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
        </el-form-item>

        <el-form-item :label="$t('deviceApartmentList.addressDetail')">
          <el-input v-model="formApartment.apartmentAddress" style="width:500px" :placeholder="$t('deviceApartmentList.addressDetail')"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="select" icon="el-icon-search">{{$t('deviceApartmentList.qurey')}}</el-button>
            <!-- <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">新增房源</el-button> -->
          </el-button-group>
        </el-form-item>

        <el-alert :title="$t('deviceApartmentList.roomDetailTitle')" type="error" :closable="false"></el-alert>
      </el-form>

      <template>
        <div v-for="o in this.tableData" :key="o.apartmentId" class="text item">
          <el-card class="box-card" shadow="hover" style="margin-top:15px;">
            <div slot="header" style="height:30px;line-height:30px;">
              <el-breadcrumb separator="|">
                <el-breadcrumb-item style="font-size:20px">{{o.apartmentType==0?$t('deviceApartmentList.fss'):o.apartmentType==1?$t('deviceApartmentList.jzs'):$t('deviceApartmentList.jds')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('deviceApartmentList.area')}}：{{o.province}} {{o.city}} {{o.area}}</el-breadcrumb-item>
                 <el-breadcrumb-item>{{$t('deviceApartmentList.addressDetail')}}: {{o.apartmentAddress}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('deviceApartmentList.apartmentName')}}: {{o.apartmentName}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('deviceApartmentList.relation')}}: {{o.linkerType==1?$t('deviceApartmentList.apartmentButler'):$t('deviceApartmentList.apartmentOwner')}}</el-breadcrumb-item>
                <!-- <el-breadcrumb-item>管家：{{o.butlerRemark==null?'无':o.butlerRemark}}</el-breadcrumb-item> -->
              </el-breadcrumb>
            </div>
            <div style="display:flex;justify-content:center;height:20px;line-height:20px;">
                <el-button type="text" icon="el-icon-arrow-down" size="mini" @click="handleEdit(o)">{{$t('deviceApartmentList.roomDetailCilck')}}</el-button>
            </div>
          </el-card>
        </div>
      </template>
    </el-main>
    <el-footer>
      <div>
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
      </div>
    </el-footer>
  </el-container>
  <!-- 分页 -->
</template>

<style lang="scss">
</style>
 
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "deviceApartmentList", //公寓列表
  data() {
    return {
      language:localStorage.getItem("language"),
      dialogVisible: false,
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      tableData: [],
      formApartment: {
        province: "",
        city: "",
        area: "",
        apartmentName:  this.$route.query.apartmentName==undefined?"":this.$route.query.apartmentName,
        apartmentAddress: ""
      }
    };
  },
  components: {
    Pagings
  },

  created() {
    this.$store.commit("province", {}); //加载省份
    this.power();
  },
  methods: {
    select() {
       this.power();
    },
    handleEdit(row) {
      this.$main.addDeviceApartmentDetailTab(row);
    },
    getCityValue(val) {
      this.$store.commit("area", { cityCode: val }); //加载区（县）
      this.formApartment.area = "";
    },
    getProvinceValue(val) {
      this.$store.commit("city", { provinceCode: val }); //加载城市
      this.formApartment.city = "";
      this.formApartment.area = "";
    },
    power() {
      var formData = new FormData();
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      if(this.formApartment.apartmentName!=""&&this.formApartment.apartmentName!=""){
         formData.append("apartmentName", this.formApartment.apartmentName);
      }
      if(this.formApartment.province!=""&&this.formApartment.province!=""){
         formData.append("province", this.formApartment.province);
      }
      if(this.formApartment.city!=""&&this.formApartment.city!=""){
         formData.append("city", this.formApartment.city);
      }
      if(this.formApartment.area!=""&&this.formApartment.area!=""){
         formData.append("area", this.formApartment.area);
      }
      if(this.formApartment.apartmentAddress!=""&&this.formApartment.apartmentAddress!=""){
         formData.append("apartmentAddress", this.formApartment.apartmentAddress);
      }
      this.$server
        .exam("/customer/apartment/listApartment", formData)
        .then(data => {
          if (data.code == 200) {
            this.tableData = data.data.records;
            this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.power();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/device/deviceApartmentList.vue